import React, { useContext } from 'react';
import OTSelect from '../../../components/engine/SelectEngine';
import Animation from '../../../components/Animation';
import { AdditionalSettingsGrid } from './RemindersStyledInputs';
import { Grid, MenuItem } from '@material-ui/core';
import sortInfoNames from '../../../utils/sortInfoNames';
import { TextString } from '../../../components/Text';
import GeneralContext from '../../GeneralContext';
import OverrideEmailTemplateDialog from '../../GeneralDialog';

const AdditionalReminderCardSettingsView = props => {
  const api = useContext(GeneralContext);
  const { reminderData, update } = props;
  const { formAdmins } = api;

  return (
    <>
      <AdditionalSettingsGrid container spacing={2}>
        <Grid item xs={6}>
          <TextString content="form-builder.reminders.remind_before_who" />
          <OTSelect
            fullWidth
            variant="contained"
            data-testid={'who-' + reminderData.id}
            onChange={props.onWhoChanged}
            value={reminderData.who}
            options={[
              {
                value: 'submitter',
                'data-testid': 'who-' + reminderData.id + '-submitter',
                text: 'form-builder.reminders.submitter'
              },

              {
                value: 'all_admins',
                'data-testid': 'who-' + reminderData.id + '-admins',
                disabled: !formAdmins.length,
                text: 'form-builder.reminders.all_admins'
              },
              {
                value: 'assignee',
                'data-testid': 'who-' + reminderData.id + '-assigned_admins',
                disabled: !formAdmins.length,
                text: 'form-builder.reminders.assigned_admin'
              },
              {
                value: 'specific',
                'data-testid': 'who-' + reminderData.id + '-specific_admin',
                disabled: !formAdmins.length,
                text: 'form-builder.reminders.spcific_admin'
              }
            ]}
          ></OTSelect>
        </Grid>
        <Grid item xs={6}>
          <Animation type="collapse" in={reminderData.who === 'specific'}>
            <TextString content="form-builder.reminders.selec_assigned_admin" />
            <OTSelect
              variant="contained"
              fullWidth
              data-testid={'who-select-admin' + reminderData.id}
              onChange={value => props.updateSelectedAdmin(value)}
              value={props.selectedAdmin}
              options={formAdmins.sort(sortInfoNames).map(adminData => ({
                value: adminData.user_id,
                text: `${adminData.info.firstName} ${adminData.info.lastName}`
              }))}
            />
          </Animation>
        </Grid>
      </AdditionalSettingsGrid>
      <OverrideEmailTemplateDialog
        open={props.isConfirmEmailTemplateOverrideDialogOpen}
        handleClose={() =>
          props.setIsConfirmEmailTemplateOverrideDialogOpen(false)
        }
        handleConfirm={props.onConfirmOverride}
        title="form-builder.reminders.template.dialog.title"
        content="form-builder.reminders.template.dialog.content"
        // variant="delete"
        buttons={[
          {
            text: 'form-builder.reminders.template.dialog.cancel',
            variant: 'outlined'
          },
          {
            text: 'form-builder.reminders.template.dialog.confirm',
            onClick: 'confirm',
            color: 'secondary'
          }
        ]}
      />
    </>
  );
};

export default AdditionalReminderCardSettingsView;
